import { render } from "./BreadcrumbNavigation.vue?vue&type=template&id=54bbcd63"
import script from "./BreadcrumbNavigation.vue?vue&type=script&lang=js"
export * from "./BreadcrumbNavigation.vue?vue&type=script&lang=js"

import "./BreadcrumbNavigation.vue?vue&type=style&index=0&id=54bbcd63&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__